import { memo } from "react";

import { FormEngineViews } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { DefaultWidgetMap } from "@com.mgmtp.a12.formengine/formengine-core/lib/view";

import { ActivityIdContext } from "../../../component/ActivityContext";

import { CustomActionContentBoxWithCloseButton } from "./CustomActionContentBoxWithCloseButton";

export const ChangelogFormEngine = memo(
	function ChangelogFormEngine(props: FormEngineViews.FormEngineProps) {
		return (
			<ActivityIdContext.Provider value={props.activityId}>
				<FormEngineViews.FormEngine
					{...props}
					widgetMap={{
						...DefaultWidgetMap,
						ActionContentbox: CustomActionContentBoxWithCloseButton(props.activityId)
					}}
				/>
			</ActivityIdContext.Provider>
		);
	},
	(previousProps, nextProps) => previousProps.activityId === nextProps.activityId
);
